"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatestSystemsList = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LatestSystemsList = styled_components_1.default.ul `
  margin: 0;
  padding: 0;
  list-style-type: none;
  max-width: 600px;
`;
//# sourceMappingURL=latest-systems-list.js.map